<template>
    <div>
        <div v-show="isShowPage">
            <div class="start-view" v-if="!isShowLive">
                <div class="logo"></div>

                <div class="options" v-if="isShowWebRTCLive">
                    <div class="live-tip">
                        本节为互动课，是否授权麦克风等权限？<br />您也可以稍后直播间内点击【准备上麦】，重新授权
                    </div>
                    <button style="background: #6a696a" @click="onClickAuth(false)">暂不授权</button>
                    <button style="margin-left: 15px" @click="onClickAuth(true)">授权进入直播间</button>
                </div>
                <div class="options" v-else>
                    <button @click="onStart">进入直播间</button>
                </div>
            </div>
            <BJYLive v-else :liveInfo="liveInfo" @liveStatusChange="onLiveStatusChange" />
        </div>
        <!-- 商品推送 -->
        <CoursePackageList
            :courseNo="isShowCoursePackageList ? courseInfo.courseNo : ''"
            :liveId="isShowCoursePackageList ? courseInfo.liveId : ''"
            :pushProductList="pushProductList"
        />

        <!-- 直播答疑课程领取 -->
        <PaidCourseReceive
            :courseInfo="packageInfo"
            v-if="isShowPaidCourseReceive"
            @authSuccess="onReceiveSuccess"
            :accountSwitch="true"
        />
        <!-- 登录 -->
        <LoginDialogPc v-if="isShowLoginDialog" v-on:authSuccess="onAuthSuccess" />
        <AuthTel v-if="isShowAuthTel" @authSuccess="onTelAuthSuccess" />

        <Watermark v-if="userInfo" />
        <Evaluate :courseInfo="courseInfo" :isShowEvaluate="isShowEvaluate" v-show="isShowEvaluate" />
        <Officialaccount ref="officialaccount" />
        <AgmAffirm ref="agmAffirm" />

        <LuckDraw
            :luckDrawUserName="luckDrawUserName"
            :luckDrawStatus="luckDrawStatus"
            v-on:closeLuckDraw="onSetLuckDrawStatus"
        />
    </div>
</template>

<script>
import { isCurrentEnv, urlQuery, timeNumToHMSText } from '@/utils/utils.js'
import { getLiveInfo, receiveCourse, getCourseLiveInfo, getPaidStatus, getLiveForbidden } from '@/utils/api.js'
import { liveHeart, userShareInvited, userShareAction, getSubscribeStatus } from '@/utils/api.js'
import { getUserInfo } from '@/utils/login.js'
import Officialaccount from '@/components/Officialaccount'
import CoursePackageList from '@/components/livePc/CoursePackageList'
import LoginDialogPc from '@/components/LoginDialogPc'
import PaidCourseReceive from '@/components/PaidCourseReceive'
import AuthTel from '@/components/AuthTel'
import Watermark from '@/components/Watermark'
import Evaluate from '@/components/Evaluate'
import AgmAffirm from '@/components/livePc/AgmAffirm'
import BJYLive from './bjy/Main'
import LuckDraw from '@/components/livePc/LuckDraw'

export default {
    components: {
        AgmAffirm,
        LoginDialogPc,
        PaidCourseReceive,
        CoursePackageList,
        AuthTel,
        Watermark,
        Evaluate,
        Officialaccount,
        BJYLive,
        LuckDraw,
    },
    data() {
        return {
            isShowPage: false,
            isShowLive: false,
            isShowWebRTCLive: false,

            packageInfo: null,
            courseInfo: null,

            liveInfo: null,

            // 推送商品相关参数
            pushProductList: [],

            userInfo: null,

            isShowLoginDialog: false,
            isShowAuthTel: false,
            isShowPaidCourseReceive: false,
            isShowEvaluate: false,
            isShowCoursePackageList: false,

            luckDrawUserName: '',
            luckDrawStatus: 0,
        }
    },
    created() {
        isCurrentEnv('Pc', 'bcloud-pc', 'bcloud-m')
        this.options = urlQuery()
        this.userInfo = getUserInfo()
        // 获取 课程token
        if (!this.options.courseToken) {
            return this.$toast({ duration: 0, message: '暂无直播课程', overlay: true })
        } else if (!this.userInfo) {
            this.isShowLoginDialog = true
        } else if (this.options.courseToken && this.userInfo) {
            this.getCourseLiveInfoApi()
        }
    },
    mounted() {
        try {
            navigator.wakeLock.request('screen').then(() => {
                console.log('Wake Lock is active')
            })
        } catch (err) {
            console.error(`${err.name}, ${err.message}`)
        }
    },
    methods: {
        onAuthSuccess(userInfo) {
            this.isShowLoginDialog = false
            this.userInfo = userInfo
            this.getCourseLiveInfoApi()
        },
        onTelAuthSuccess(userInfo) {
            this.isShowAuthTel = false
            this.userInfo = userInfo
            this.receiveCourseApi()
        },
        onReceiveSuccess() {
            this.isShowPaidCourseReceive = false
            this.getLiveInfoApi()
        },

        onStart() {
            this.isShowLive = true
        },
        onClickAuth(auth = false) {
            if (auth) {
                window.sessionStorage.setItem('prepareSpeakStatus', 1)
            } else {
                window.sessionStorage.setItem('prepareSpeakStatus', 0)
            }
            this.isShowLive = true
        },
        onLiveStatusChange(statue) {
            console.log('直播状态改变', statue)
            // 课程已结束
            if (statue === 'class_end') {
                this.clearTimer()
            } else if (statue === 'class_start') {
                console.log('直播状态改变', statue, '开始计时')
                this.startTimer()
            } else if (statue === 'c_class_show') {
                // 自定义状态
                this.isShowCoursePackageList = true
            } else if (statue === 'kick_out') {
                // 被踢出直播间
                window.location.reload()
            } else if (statue === 'login_conflict') {
                // 其他地方登录账号
                this.$toast({ duration: 0, message: '当前账号在其他地方登录', overlay: true })
                this.clearTimer()
            }
        },

        getCourseLiveInfoApi() {
            getCourseLiveInfo({ courseToken: this.options.courseToken }).then((res) => {
                try {
                    document.title = res.data.course.title
                    this.packageInfo = res.data.coursePackage
                    this.courseInfo = res.data.course
                    if (this.courseInfo.provider === 'talkfun') {
                        //跳转到欢拓
                        isCurrentEnv('', 'bcloud-pc', 'live-pc')
                        return
                    }
                } catch (error) {
                    this.$toast('获取课程信息失败')
                    return
                }

                if (res.data.audition && res.data.audition.validFlag) {
                    // 试听
                    this.getLiveInfoApi()
                } else {
                    this.getPaidStatusApi()
                }
                this.userShareInvitedApi()
            })
        },

        getPaidStatusApi() {
            getPaidStatus({ packageNo: this.packageInfo.packageNo, userId: this.userInfo.id }).then((res) => {
                if (res.data.status) {
                    this.getLiveInfoApi()
                } else if (this.packageInfo.type === 1) {
                    const collects = this.packageInfo.collects || ''
                    const collectsList = collects.split(',')
                    // 公开课 未报名&没有手机号 且collects 含有tel
                    if (!this.userInfo.telNo && collects && collectsList.includes('tel')) {
                        this.isShowAuthTel = true
                    } else {
                        // 如果用户未报名则直接报名 且课程为公开课
                        this.receiveCourseApi()
                    }
                } else if ([2, 3].includes(this.packageInfo.type)) {
                    this.$toast({ duration: 0, message: '付费课程，暂无观看权限', overlay: true })
                } else if (this.packageInfo.type === 4) {
                    // 直播答疑课
                    this.isShowPaidCourseReceive = true
                    this.$forceUpdate()
                }
            })
        },
        receiveCourseApi() {
            const params = { packageNo: this.packageInfo.packageNo, userId: this.userInfo.id }
            if (this.options.sn) {
                params.sourceFrom = this.options.sn
                params.sourceType = 2
                if (this.options.sn === 'invite') {
                    params.sourceFrom = this.options.inviter
                    params.sourceType = 4
                }
            }
            receiveCourse(params).then(() => {
                this.getLiveInfoApi()
            })
        },

        getLiveInfoApi() {
            getLiveInfo(this.options.courseToken).then((res) => {
                if (res.data.extra && res.data.extra.url) {
                    window.location.href = res.data.extra.url
                    return
                }
                this.isShowPage = true
                this.liveInfo = {
                    ...res.data.extra,
                    accessToken: res.data.accessToken,
                    webrtc: this.courseInfo.mirageType === 2 ? 1 : 0,
                    courseInfo: this.courseInfo,
                    userForbiddenTalk: false,
                }

                if (res.data.agreementStatus && res.data.agreementStatus.needCertNo) {
                    this.$refs.agmAffirm.onShow(res.data.agreementStatus)
                } else {
                    this.getSubscribeStatusApi()
                }

                // 检测是否试听
                this.checkLiveState(res.data.expireIn)

                // 百家云逻辑
                this.initBJY()
                // 查询禁言状态
                getLiveForbidden(this.userInfo.id).then((res) => {
                    this.liveInfo.userForbiddenTalk = res.data.forbiddenTalk
                })

                if (this.liveInfo.webrtc === 1) {
                    var prepare = !window.sessionStorage.getItem('prepareSpeakStatus')
                    if (!prepare && !BJY.browser.wechat) {
                        //互动课，没准备，需要显示线授权准备
                        this.isShowWebRTCLive = true
                    }
                }
            })
        },

        onClipUrl() {
            if (navigator && navigator.clipboard) {
                const _host = `${window.location.origin}${window.location.pathname}`
                const _url = `${_host}?courseToken=${this.options.courseToken}&inviter=${this.userInfo.id}&sn=invite`

                navigator.clipboard.writeText(_url).then(() => {
                    this.$toast('复制成功，赶紧发给好友吧～')
                })
            } else {
                this.$toast('复制失败，请手动复制地址栏发送给好友～')
            }
            userShareAction({ courseId: this.courseInfo.id, userId: this.userInfo.id })
        },

        userShareInvitedApi() {
            if (this.options.inviter) {
                userShareInvited({
                    courseId: this.courseInfo.id,
                    userId: this.userInfo.id,
                    inviter: this.options.inviter,
                })
            }
        },

        getSubscribeStatusApi() {
            if (this.userInfo) {
                getSubscribeStatus({ userId: this.userInfo.id }).then((res) => {
                    if (!res.data || !res.data.status) {
                        this.$refs.officialaccount.onShow()
                    }
                })
            }
        },

        // 判断是否试听地址， 对于试听课程进行倒计时判断，超出时间的直接踢出直播间
        checkLiveState(_timeNum) {
            if (_timeNum && _timeNum > 0) {
                const _maxTime = 2 * 60 * 60 * 1000
                const _actualTime = Math.min(_timeNum, _maxTime)
                console.log('试听地址 开始计时', timeNumToHMSText(parseInt(_timeNum / 1000)))
                setInterval(() => {
                    this.$toast({ duration: 0, message: '试听已结束', overlay: true })
                    this.clearTimer()
                }, _actualTime)
            }
        },
        // 定时任务 观看异常 取消定时上报
        startTimer() {
            this._timer = setInterval(() => {
                liveHeart({
                    uid: this.userInfo.id,
                    cid: this.courseInfo.id,
                })
                    .then(() => {})
                    .catch(() => {})
                // 检测当前直播进度,直播一小时 显示评价窗口
                const nowTime = +new Date()
                const startTime = +new Date(this.courseInfo.startTime)
                const showEvaluateState = window.sessionStorage.getItem('showEvaluateState')
                if (nowTime - startTime > 60 * 60 * 1000 && !showEvaluateState) {
                    this.isShowEvaluate = true
                    window.sessionStorage.setItem('showEvaluateState', true)
                }
            }, 30 * 1000)
        },
        clearTimer() {
            clearInterval(this._timer)
        },

        initBJY() {
            window.BJY.api.onReceiveBroadcast('third:sell_product', (fromeId, data) => {
                console.log(data)
                const _value = data[0]
                this.pushProductList.unshift({
                    productNo: _value.productNo,
                    type: _value.type,
                })
            })
            window.BJY.api.onReceiveBroadcast('third:lottery', (fromeId, data) => {
                const res = data[0]
                if (res.type === 'start') {
                    this.onSetLuckDrawStatus(1)
                } else if (res.type === 'stop') {
                    this.luckDrawUserName = [{ nickname: res.nickname }]
                    this.onSetLuckDrawStatus(3)
                }
            })

            let barrage = null
            window.BJY.api.onReceiveBroadcast('third:system_message', (fromeId, data) => {
                if (!data || !data.length) return
                if (!barrage) {
                    barrage = new window.BJY.Barrage({
                        container: window.$('.class-panel'),
                        speed: 200,
                    })
                    barrage.open()
                }
                data.forEach((item) => {
                    if (barrage && item.type === 'to_pay') {
                        barrage.send(`${item.name} ${item.action} ${item.target || ''}`)
                    }
                })
            })
        },
        onSetLuckDrawStatus(status) {
            this.luckDrawStatus = status
            if (status === 0) {
                this.luckDrawUserName = ''
            }
        },
    },
}
</script>

<style lang="scss">
.start-view {
    width: 100vw;
    height: 100vh;
    font-size: 14px;
    line-height: 1.2;
    position: relative;
    .logo {
        display: flex;
        width: 100%;
        height: 50%;
        top: 20%;
        position: absolute;
        background: image-set(url('https://res.peki.vip/20220806/9a50de15760246e8b3ee04796fc93e02.png') 2x) 50% 0%
            no-repeat;
    }

    .options {
        position: absolute;
        top: 50%;
        left: 50%;
        margin-left: -200px;
        width: 400px;
        text-align: center;

        .live-tip {
            color: #fc5f5f;
            font-size: 16px;
        }
        button {
            height: unset;
            background: #1795ff;
            margin-top: 15px;
            color: #fff;
            padding: 10px 12px;
            font-size: 16px;
            border-radius: 3px;
            transition: background-color 0.3s;
            border: none;
        }
    }
}
.bjy-barrage {
    z-index: 1;
    user-select: none; // 禁用选择文字
    white-space: pre;
    will-change: transform;
    font-size: 14px;
    color: #fff;
    padding: 6px 15px;
    background: rgba(1, 1, 1, 0.6);
    line-height: 1em;
    border-radius: 30px;
}
</style>
